import { morning8am } from '@/util/helpers/time-helpers';
import { DAILY, NEW_RESULTS } from './enums/EnumCreateAlert';

// these must match EnumTriggerType.java
export const ZAPIER = 'zapier';
export const SLACK = 'slack';
export const EMAIL = 'email';

class AlertRef {
  constructor(
    id,
    name,
    trigger,
    frequency,
    recipients,
    viewSeries,
    showChanged,
    disabled,
    triggerType,
    message,
    time,
  ) {
    this._id = id; // uuid
    this._name = name; // string
    this._trigger = trigger; // see ModalAddAlert triggers
    this._frequency = frequency; // see ModalAddAlert frequencies
    this._recipients = recipients; // list of emails/slack channels
    this._viewSeries = viewSeries; // uuid
    this._showChanged = showChanged; // boolean
    this._disabled = disabled; // boolean
    this._triggerType = triggerType; // zapier, slack or email: see consts above!
    this._message = message;
    this._time = time; // time as ISO timestamp (e.g. 2019-12-17T03:00:00Z)
  }

  static build(a) {
    return new AlertRef(
      a._id,
      a._name,
      a._trigger,
      a._frequency,
      a._recipients,
      a._viewSeries,
      a._showChanged,
      a._disabled,
      a._triggerType,
      a._message,
      a._time,
    );
  }

  static empty(triggerType) {
    return new AlertRef(
      null, // _id
      '', // _name:
      NEW_RESULTS, // _trigger:
      DAILY, // _frequency
      [], // _recipients:
      '', // _viewSeries:
      false, // _showChanged:
      true, // _disabled
      triggerType, // _triggerType:
      '', // message
      morning8am(),
    );
  }

  id() {
    return this._id;
  }

  name() {
    return this._name;
  }

  trigger() {
    return this._trigger;
  }

  frequency() {
    return this._frequency;
  }

  recipients() {
    return this._recipients;
  }

  viewSeries() {
    return this._viewSeries;
  }

  showChanged() {
    return this._showChanged;
  }

  disabled() {
    return this._disabled;
  }

  triggerType() {
    return this._triggerType;
  }

  message() {
    return this._message;
  }

  time() {
    return this._time;
  }
}

export default AlertRef;
